
































import AdminProfile from '@/views/Admin/Profile/AdminProfile/AdminProfile.vue';
import LogoList from '@/views/Admin/Profile/Logo/LogoList.vue';
import NewsList from '@/views/Admin/Profile/notifications/NewsList.vue';
import MonthlyEmailSetting from '@/views/Admin/Profile/MonthlyEmailSetting/MonthlyEmailSetting.vue';
import GlobalSetting from '@/views/Admin/Profile/GlobalSetting/GlobalSetting.vue';
import EmailConfigList from '@/views/Admin/Profile/EmailConfigSetting/EmailConfigList.vue';
import TabCard from '@/components/Tabs.vue';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
@Component({
  computed: {...mapGetters(['currentTab', 'userDetails'])},
  methods: {...mapActions(['setCurrentTab'])},

  components: {
    AdminProfile,
    LogoList,
    NewsList,
    MonthlyEmailSetting,
    GlobalSetting,
    EmailConfigList,
    TabCard,
  },
})
export default class ProfilePanel extends Vue {
  setCurrentTab: any;
  tabs: Array<String> = [
    'adminprofile',
    'applicaitonlogo',
    'notifications',
    'globalSetting',
    'emailConfigurationSetting',
    'monthlyEmailSetting',
  ];
  userDetails: any;

  get isSuperAdmin() {
    return this.userDetails?.type?.roleId == process.env?.VUE_APP_SUPER_ADMIN_ID ? true : false;
  }
  get getTabs() {
    return this.isSuperAdmin ? this.tabs : this.tabs.filter((me) => me !== 'adminprofile');
  }

  get getInitialTab() {
    return this.$store.getters.currentTab.child || this.isSuperAdmin ? 'adminprofile' : 'applicaitonlogo';
  }

  changeTab(activeTab) {
    this.setCurrentTab({parent: 'profile', child: activeTab});
  }
  @Watch('isSuperAdmin', {immediate: true})
  onUserChange() {
    this.getInitialTab;
    this.getTabs;
  }
}
